import type { SupportedCurrency } from "./exchangeRates";

// Mapa país (ISO-3166 alpha-2) → moeda de exibição preferida.
// Apenas cobrimos moedas suportadas pela taxa AOA. Para outros países, cai em USD.
const MAP: Record<string, SupportedCurrency> = {
  AO: "AOA",
  PT: "EUR", ES: "EUR", FR: "EUR", DE: "EUR", IT: "EUR", NL: "EUR", BE: "EUR",
  IE: "EUR", GR: "EUR", AT: "EUR", FI: "EUR", LU: "EUR", MT: "EUR", CY: "EUR",
  EE: "EUR", LV: "EUR", LT: "EUR", SK: "EUR", SI: "EUR", HR: "EUR", MC: "EUR",
  SM: "EUR", VA: "EUR", AD: "EUR", ME: "EUR",
  BR: "BRL",
  ZA: "ZAR",
  US: "USD", GB: "USD", CA: "USD", AU: "USD", NZ: "USD", JP: "USD", CN: "USD",
  IN: "USD", RU: "USD", MX: "USD", AR: "USD", CH: "USD", SE: "USD", NO: "USD",
  DK: "USD", KR: "USD", SG: "USD", HK: "USD", AE: "USD", SA: "USD", QA: "USD",
};

export function getCurrencyForCountry(code: string | null | undefined): SupportedCurrency {
  if (!code) return "USD";
  return MAP[code.toUpperCase()] || "USD";
}
